import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_5xebl4mzo3: FaireBrandEntity = {
  token: "b_5xebl4mzo3",
  type: "brand",
  name: "Girl Nation | Kids Jewelry | Easter Gifts",
  avatarUrl:
    "https://cdn.faire.com/fastly/f7f885518f85dc7444f6a18163f021480e501d6916d2749b278924f9665581c0.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/25ca85b31c456b1497eea2e7ce5c7dab3300112afa91ac40d0a2bd3b0fdbae52.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/f7f885518f85dc7444f6a18163f021480e501d6916d2749b278924f9665581c0.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/25ca85b31c456b1497eea2e7ce5c7dab3300112afa91ac40d0a2bd3b0fdbae52.jpeg",
  location: "Van Nuys, CA, USA",
  minimumOrderDollars: 150,
  rating: 5,
  reviewCount: 181,
  isTopShop: true,
  isInsider: true,
  description:
    "A world where girls are connected by fun friends, original ideas, creative energy, new experiences and unique styles. Celebrate life's little treasures that bring joy to young girls with on-trend charm! \n\nSweet and sassy with a touch of whimsy, this adorable jewelry and accessory collection is hypoallergenic, nickel free and lead free.  \n\nWe invite you to experience the whimsy & delightful charm of GIRL NATION!\n\nIf you love Girl Nation, you're sure to love our other line of creative kids' products, The Piggy Story, as well! Shop us here: https://www.faire.com/brand/b_7mdmaeu8z9 ",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:44:35.884Z",
    importedBy: "entity-db-cli",
  },
};
